import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import { translations } from '../i18n';
function Contact({ language }) {
  const t = translations[language];
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('तुमचा संदेश पाठवला गेला आहे!');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section 
        className="hero" 
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">{t.contactUs}</h1>
          <p className="page-hero-sub">आम्हाला संपर्क करा</p>
        </div>
      </motion.section>

      <section className="contact-section">
        <div className="contact-content">
          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <h3 className="sub-heading">पत्ता</h3>
                <p>ग्रामपंचायत कार्यालय, नाशेरा<br />तालुका: मोखाडा | जिल्हा: पालघर<br />महाराष्ट्र - ४०१६०४</p>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div>
                <h3 className="sub-heading">फोन</h3>
                <p>+91 7620 135 257</p>
              </div>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div>
                <h3 className="sub-heading">ईमेल</h3>
                <p>gpnasherapsmokhada@gmail.com</p>
              </div>
            </div>
            <div className="contact-item">
              <FaClock className="contact-icon" />
              <div>
                <h3 className="sub-heading">कार्यालय वेळ</h3>
                <p>सोमवार - शुक्रवार: 10:00 AM - 5:00 PM</p>
              </div>
            </div>
          </motion.div>

          <motion.form 
            className="contact-form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="form-group">
              <label>नाव</label>
              <input 
                type="text" 
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required 
              />
            </div>
            <div className="form-group">
              <label>ईमेल</label>
              <input 
                type="email" 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required 
              />
            </div>
            <div className="form-group">
              <label>संदेश</label>
              <textarea 
                rows="5"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-btn">संदेश पाठवा</button>
          </motion.form>
        </div>
      </section>
    </div>
  );
}

export default Contact;
